import baseEditForm from 'formiojs/components/_classes/component/Component.form';

export default (...extend) => {
  return baseEditForm(
    [
      {
        key: 'display',
        components: [
          {
            key: 'inputClass',
            label: 'Custom Input CSS Class',
            type: 'textfield',
            input: true,
            weight: 12,
          },
        ],
      },
      {
        key: 'data',
        components: [],
      },
      {
        key: 'validation',
        components: [],
      },
      {
        key: 'api',
        components: [],
      },
      {
        key: 'conditional',
        components: [],
      },
      {
        key: 'logic',
        components: [],
      },
      {
        key: 'autoCompleteTab',
        label: 'Auto Complete Settings',
        components: [
          {
            weight: -10,
            label: 'Free Form?',
            key: 'isFreeform',
            type: 'checkbox',
            input: true,
          },
          {
            weight: -10,
            label: 'Code List Name',
            key: 'codeListName',
            type: 'textfield',
            input: true,
            validate: {
              required: true,
            },
          },
          {
            weight: -10,
            label: 'Minimum Length Required Before Auto Complete Suggestion',
            key: 'minLength',
            type: 'number',
            input: true,
            validate: {
              required: true,
            },
          },
          {
            type: 'select',
            input: true,
            validate: {
              required: true,
            },
            label: 'Auto Complete Search Type',
            weight: 12,
            key: 'autoCompleteSearchType',
            dataSrc: 'values',
            data: {
              values: [
                { label: 'Contains Text', value: 'containsText' },
                {
                  label: 'Starts With',
                  value: 'startsWith',
                },
              ],
            },
          },
          {
            type: 'select',
            input: true,
            validate: {
              required: true,
            },
            label: 'Code Value Display Type',
            weight: 12,
            key: 'codeValueDisplayType',
            dataSrc: 'values',
            data: {
              values: [
                { label: 'Description Only', value: 'descriptionOnly' },
                {
                  label: 'Value Only',
                  value: 'valueOnly',
                },
                {
                  label: 'Value And Description',
                  value: 'valueAndDescription',
                },
                {
                  label: 'Description And Value',
                  value: 'descriptionAndValue',
                },
              ],
            },
          },
          {
            type: 'select',
            input: true,
            validate: {
              required: true,
            },
            customConditional: 'show = data.isFreeform === false;',
            label: 'Code Value Save Type',
            weight: 12,
            key: 'codeValueSaveType',
            dataSrc: 'values',
            data: {
              values: [
                { label: 'Description Only', value: 'descriptionOnly' },
                {
                  label: 'Value Only',
                  value: 'valueOnly',
                },
                {
                  label: 'Value And Description',
                  value: 'valueAndDescription',
                },
                {
                  label: 'Description And Value',
                  value: 'descriptionAndValue',
                },
              ],
            },
          },
          {
            weight: -10,
            label: 'Invalid Selection Text',
            key: 'invalidSelectionText',
            type: 'textfield',
            input: true,
          },
          {
            weight: -10,
            label: 'Is Cascade?',
            key: 'isCascade',
            type: 'checkbox',
            input: true,
            disabled: true, // disabling as cascading is not currently functional
          },
          {
            weight: -10,
            label: 'Parent API Name',
            key: 'parentApiName',
            type: 'textfield',
            input: true,
            validate: {
              required: true,
            },
            customConditional: 'show = data.isCascade === true;',
          },
          {
            weight: -10,
            label: 'Parent Code List Name',
            key: 'parentCodeListName',
            type: 'textfield',
            input: true,
            validate: {
              required: true,
            },
            customConditional: 'show = data.isCascade === true;',
          },
          {
            type: 'select',
            input: true,
            validate: {
              required: true,
            },
            customConditional: 'show = data.isCascade === true;',
            label: 'Parent Code Value Save Type',
            weight: 12,
            key: 'parentCodeValueSaveType',
            dataSrc: 'values',
            data: {
              values: [
                { label: 'Description Only', value: 'descriptionOnly' },
                {
                  label: 'Value Only',
                  value: 'valueOnly',
                },
                {
                  label: 'Value And Description',
                  value: 'valueAndDescription',
                },
                {
                  label: 'Description And Value',
                  value: 'descriptionAndValue',
                },
              ],
            },
          },
          {
            type: 'textfield',
            customConditional: 'show = data.isCascade === true;',
            key: 'parentComponentInitInterval',
            input: true,
            label: 'Interval in which to check parent component (ms)',
            defaultValue: '500',
          },
          {
            type: 'textfield',
            customConditional: 'show = data.isCascade === true;',
            key: 'parentComponentInitMaxAttempts',
            input: true,
            label: 'Max attempts to locate parent component',
            defaultValue: '10',
          },
        ],
      },
    ],
    ...extend
  );
};
